module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "repairModeManage"
    }
  }, [_c('div', {
    staticClass: "repair container"
  }, [_c('h4', [_vm._v("维修方式")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.repairLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "repairListPart listPart",
      class: {
        'active': item.isLength
      },
      on: {
        "click": function($event) {
          return _vm.selectRepairClass(item, index)
        }
      }
    }, [_c('span', {
      class: {
        active: _vm.activeRepairIndex === index
      }
    }, [_c('i', {
      staticClass: "el-icon-check"
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.solutionName))]), _vm._v(" "), (_vm.repairAuth.exitRepair) ? _c('span', {
      staticClass: "exitBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.exitRepair(item)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.repairAuth.deleRepair) ? _c('i', {
      staticClass: "el-icon-error activeDelBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleRepair(item)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.repairAuth.newRepair) ? _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        return _vm.newRepair()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textRepairMenu[_vm.dialogRepairStatus],
      "visible": _vm.dislogRepair,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogRepair = $event
      },
      "close": function($event) {
        return _vm.emptyRepairDialog('RepairForm')
      }
    }
  }, [_c('el-form', {
    ref: "RepairForm",
    attrs: {
      "model": _vm.RepairForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.RepairFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "维修方式：",
      "prop": "solutionName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入维修方式(不超过200字)",
      "maxlength": "200"
    },
    model: {
      value: (_vm.RepairForm.solutionName),
      callback: function($$v) {
        _vm.$set(_vm.RepairForm, "solutionName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "RepairForm.solutionName"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogRepairStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addRepairFormSubmitBtn('RepairForm')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveRepairFormSubmitBtn('RepairForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyRepairDialog('RepairForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-0db6a61a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/repairModeManage.vue
// module id = 1583
// module chunks = 0